import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'products',
			component: () => import('./components/products/_ProductsPage.vue'),
		},
		{
			path: '/firmware',
			name: 'firmware',
			component: () => import('./components/firmware/_FirmwarePage.vue')
		},
		{
			path: '/licenses',
			name: 'licenses',
			component: () => import('./components/licenses/_LicensesPage.vue')
		},
		{
			path: '/coupons',
			name: 'coupons',
			component: () => import('./components/coupons/_CouponsPage.vue')
		},
		{
			path: '/serials',
			name: 'serials',
			component: () => import('./components/serials/_SerialsPage.vue')
		},
		{
			path: '/installs',
			name: 'installs',
			component: () => import('./components/installs/_InstallsPage.vue')
		},
		{
			path: '/users',
			name: 'users',
			component: () => import('./components/users/_UsersPage.vue')
		}
	]
})
